var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("Thank you")]),_c('p',[_vm._v("Your payment has been processed.")]),_c('p',[_c('router-link',{staticClass:"button is-primary",attrs:{"to":"/aircraft"}},[_vm._v("View/Add aircraft")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }